import "./insFormattedNumeral.scss";
import React from "react";
import { numberFormatters } from "common";
import { NumberFormatKind } from "common/types";
import { userPreferencesDefaults } from "common/user-preferences-defaults";
import { useGetUserPreferences } from "hooks/use-get-user-preferences";
const useGetFormattedValueParts = (value, maximumSignificantDigits, minimumSignificantDigits) => {
    const [userPreferences] = useGetUserPreferences();
    if (!Number.isFinite(value)) {
        return ["", ""];
    }
    const formattedNumber = numberFormatters(value, NumberFormatKind.compact, { maximumSignificantDigits, minimumSignificantDigits });
    const settings = userPreferences ?? userPreferencesDefaults;
    const last = new Intl.NumberFormat(settings?.region ?? userPreferencesDefaults.region, { notation: "compact" }).formatToParts(value)
        .pop();
    // To be replaced when switching to typescript 4.2 by a simple if (last?.type === "compact")
    if (last && last?.type === "compact") {
        const unit = last.value, [number] = formattedNumber.split(unit);
        return [number, unit];
    }
    return [formattedNumber, ""];
};
export const InsFormattedNumeral = ({ value, maximumSignificantDigits, minimumSignificantDigits }) => {
    const [number, unit] = useGetFormattedValueParts(value, maximumSignificantDigits, minimumSignificantDigits);
    return React.createElement("div", { className: "ins-formatted-numeral" },
        number,
        React.createElement("span", { className: "unit" }, unit));
};
